"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ExtendedAxiosError = require("./ExtendedAxiosError");
Object.keys(_ExtendedAxiosError).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ExtendedAxiosError[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ExtendedAxiosError[key];
    }
  });
});
var _GraphqlError = require("./GraphqlError");
Object.keys(_GraphqlError).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GraphqlError[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _GraphqlError[key];
    }
  });
});
var _EmptyBodyGraphqlError = require("./EmptyBodyGraphqlError");
Object.keys(_EmptyBodyGraphqlError).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EmptyBodyGraphqlError[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _EmptyBodyGraphqlError[key];
    }
  });
});
var _NonOkResponseGraphqlError = require("./NonOkResponseGraphqlError");
Object.keys(_NonOkResponseGraphqlError).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NonOkResponseGraphqlError[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NonOkResponseGraphqlError[key];
    }
  });
});
//# sourceMappingURL=index.js.map